import { closestTo } from "date-fns";

export const closerToDate = (dates: string[]) => {
  if (!dates.length) return undefined;
  const dateToCompare = new Date();
  const result = closestTo(
    dateToCompare,
    dates.map((date) => new Date(date))
  );
  return result;
};

export const newDateWithoutTime = (date: Date = new Date()) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
